import { css } from "styled-components";
import token from "styled-token";
import { fontSizeMixin } from "../fontSizeMixin";
import { lineHeightMixin } from "../lineHeightMixin";
import { spaceMixin } from "../spaceMixin";
import { StyledIcon } from "../../components/Icon/Icon";
import { StyledIconSort, StyledSortIconWrapper, StyledTableHeaderCellLabelWrapper } from "../../components/Table/TableSortIcon";
import { TABLE_SORT_DIRECTIONS } from "../../constants/TABLE";

var sortIconCSS = function sortIconCSS(props) {
  var align = props.align,
      size = props.size;
  return token({
    headerFontType: "Table.headerFontType." + size,
    headerSortIconColor: "Table.headerSortIconColor"
  }, function (_ref) {
    var headerFontType = _ref.headerFontType,
        headerSortIconColor = _ref.headerSortIconColor;
    var headerFontSize = fontSizeMixin(headerFontType, function (fontSize) {
      return fontSize.value;
    })(props);
    var headerLineHeight = lineHeightMixin(headerFontType, function (lineHeight) {
      return lineHeight.value;
    })(props);
    return css(["", "{margin-", ":", ";color:", ";white-space:nowrap;", "{margin-top:", "px;}}"], StyledSortIconWrapper, align === "right" ? "right" : "left", spaceMixin("xs")(props), headerSortIconColor, StyledIcon, (headerLineHeight - headerFontSize) / 2);
  })(props);
};

var hoverCSS = function hoverCSS(props) {
  return token("Table.rowBackgroundColorHover", function (backgroundColor) {
    return css(["&&:hover{background-color:", ";cursor:pointer;}"], backgroundColor);
  })(props);
};

var sortableCSS = function sortableCSS(props) {
  var sortDirection = props.sortDirection;

  if (sortDirection !== TABLE_SORT_DIRECTIONS.none) {
    return "";
  }

  return css(["", "{opacity:0;}", ":hover,", ":focus{", "{opacity:1;}}"], StyledIconSort, StyledTableHeaderCellLabelWrapper, StyledTableHeaderCellLabelWrapper, StyledIconSort);
};

var focusCSS = function focusCSS(props) {
  var size = props.size;
  var focusSpread = 4;
  return token({
    focusShadow: "shadows.focus",
    verticalPadding: "Table.verticalPadding." + size,
    horizontalPadding: "Table.horizontalPadding." + size
  }, function (_ref2) {
    var focusShadow = _ref2.focusShadow,
        verticalPadding = _ref2.verticalPadding,
        horizontalPadding = _ref2.horizontalPadding;
    return css(["&&{height:0;height:-moz-fit-content;user-select:none;}", "{display:block;height:100%;position:relative;&:focus{outline:none;box-shadow:none;}&:focus:before{box-shadow:", ";content:\"\";display:block;outline:none;position:absolute;top:-", "px;right:-", "px;bottom:-", "px;left:-", "px;}}"], StyledTableHeaderCellLabelWrapper, focusShadow, verticalPadding - focusSpread, horizontalPadding - focusSpread, verticalPadding - focusSpread, horizontalPadding - focusSpread);
  })(props);
};
/** @class TableSortableHeaderCellMixin */

/** @method */


export var TableSortableHeaderCellMixin = function TableSortableHeaderCellMixin(props) {
  return [sortIconCSS(props), hoverCSS(props), sortableCSS(props), focusCSS(props)];
};